import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom';
import { Link } from 'react-router-dom';
import NlpUsage from './NlpUsage';
import $ from 'jquery';

class NlpUsageTab extends Component {
  componentDidMount() {
    (function () {
      var currentPath = window.location.href;

      var path = window.origin + "/platform/cloud-nlp/usage";
      var path1 = window.origin + "/platform/cloud-nlp/usage/";
      if (currentPath === path || currentPath === path1) {
        $("#apiusage-tab").addClass('active');
      }
      else {
        $("#" + localStorage.getItem("last-project-settings-tab")).addClass('active')
      }
      $("#-tab")
        .on("click", function () {
          $("#apiusage-tab")
            .removeClass('active');
          localStorage.setItem("last-project-settings-tab", $(this)[0].id);

          $(this).addClass('active')

        })


    })();
  }
  render() {
    return (

      <div id="tabPage">
        <div className="content" style={{ backgroundColor: "#F9F9FB" }}>

          <link rel="shortcut icon" type="image/png" href="assets/images/bot.ico" />
          <title> Dheeyantra | Clusters Details</title>
          {/* Font Awesome Icons */}
          <link rel="stylesheet" href="plugins/font-awesome/css/font-awesome.min.css" />
          {/* IonIcons */}
          <link rel="stylesheet" href="//code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css" />
          <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
          {/* Theme style */}
          <link rel="stylesheet" href="assets/css/adminlte.css" />
          <link href="https://cdn.jsdelivr.net/npm/gijgo@1.9.6/css/gijgo.min.css" rel="stylesheet" />
          <link rel="stylesheet" href="assets/css/custom-style.css" />
          <link rel="stylesheet" href="assets/css/styles.css" />
          <div className="content-header" >
            <div className="container-fluid">
              <div className="row">
                <div className="col-sm-5">
                  <h1 className="m-0 page-title">Usage</h1>
                  <h6 className="taglineTxt"></h6>
                </div>

              </div>
            </div>
          </div>
          <div className="container-fluid" >
            {/* Nav tabs */}
            <div className="d-flex p-0 ">

              <ul className="nav nav-pills mr-auto" >
                <Link to="/cloud-nlp/usage" style={{ textDecoration: 'none' }}>

                  <li className="nav-item">
                    <a className="nav-link" id="apiusage-tab">Api Usage Record</a>
                  </li></Link>

              </ul>
            </div>
          </div>
        </div>
        <Switch>
          <Route path="/cloud-nlp/usage" component={NlpUsage}></Route>
        </Switch>
      </div>

    );
  }
}
export default NlpUsageTab;


// WEBPACK FOOTER //
// ./src/nlpUi/NlpUsageTab.js